import { SIDE_PANEL_TRANSITION } from '../../client/constants';
import { getFitToWidthPdfScale } from './fitToWidthUtils';
import { setScale } from './setScale';
import panelTypeConfig from '../../client/components/sidebar/panel/panelTypeConfig';

export const preserveFitToWidth = () => (dispatch, getState) => {
  const { stayFitToWidth, sidebar: { isOpen } } = getState();
  if (stayFitToWidth) {
    setTimeout(() => dispatch(setScale(getFitToWidthPdfScale(isOpen))), SIDE_PANEL_TRANSITION);
  }
};

function findGroup(state, group) {
  return state.sidebar.panelGroups.find(g => g.id === group);
}

export function findPanel(state, group, type) {
  const panelGroup = findGroup(state, group);
  return panelGroup.panels.find(p => p.type === type);
}

export function findNextPanel(state, panel) {
  const panelGroup = findGroup(state, panel.group);
  const maxIndex = panelGroup.panels.length - 1;
  if (panel.index < maxIndex) {
    return panelGroup.panels[panel.index + 1];
  }

  return null;
}

export function isPanelOpen(state, group, type) {
  return !!findPanel(state, group, type);
}

export function shouldRestoreOpenerFocus(state, group, type) {
  const { sidebar: { isOpen, lastPanelClosed } } = state;
  return !isOpen && lastPanelClosed !== null
    ? lastPanelClosed.group === group && lastPanelClosed.type === type
    : false;
}

export function findVisibleGroup(state) {
  const { sidebar: { panelGroups } } = state;
  const orderedGroups = [...panelGroups].reverse();
  return orderedGroups.find(({ panels }) => panels.length > 0);
}

export const isStackedPanelGroup = panels => panels.some(panel => panelTypeConfig[panel.type]?.display === 'stacked');

export function multiplePanelsOpen(state) {
  const visibleGroup = findVisibleGroup(state);
  if (visibleGroup && !isStackedPanelGroup(visibleGroup.panels)) {
    const { panels } = visibleGroup;
    return panels.length > 1;
  }

  return false;
}
